import { useStoreState } from "easy-peasy";
import React from "react";
import Accordion from "../../components/Accordion/Accordion";
import SideMenu from "../../components/SideMenu/SideMenu";
import "./Security.scss";

const Security = () => {
  const securities = useStoreState((state) => state.security.securities);

  return (
    <div className="mainSecurity">
      <div className="navLine"></div>
      <div className="container">
        <SideMenu />
        <div className="main">
          {securities.map((el, index) => (
            <React.Fragment key={index}>
              {el.type == "text" && (
                <>
                  <div className="header">{el.title}</div>
                  <div
                    className="ql-editor text"
                    dangerouslySetInnerHTML={{ __html: el.description }}
                  ></div>
                </>
              )}
              {el.type == "accordion" && (
                <div
                  style={{
                    width: "100%",
                    marginBottom:
                      securities[index + 1]?.type != el.type ? "30px" : "",
                  }}
                >
                  <Accordion
                    type={3}
                    data={el.description}
                    title={el.title}
                    key={index}
                  />
                </div>
              )}
              {el.type == "table" && (
                <div
                  className="table"
                  style={{
                    marginBottom:
                      securities[index + 1]?.type != el.type ? "30px" : "",
                  }}
                >
                  <div className="td left">{el.title}</div>
                  <div
                    className="ql-editor td right"
                    dangerouslySetInnerHTML={{ __html: el.description }}
                  ></div>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

Security.getInitialProps = async (props) => {
  if (props.isServer) {
    await props.store.dispatch.security.getSecurity();
  } else {
    const store = require("../../client");
    if (store.default.getState().security.securities.length < 1) {
      await store.default.dispatch.security.getSecurity();
    }
  }
  return { whatever: "stuff" };
};

export default Security;
